import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { ValueFilterIcon } from "../icons";

export default {
  options: {
    group: "config",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("value-filter/list") !== -1,
  },
  icon: ValueFilterIcon,
  list: List,
  edit: Edit,
  create: Create,
};
